// Tour labels shown next to customer reviews. The review texts themselves stay in their original language.
// Keys are the Portuguese labels stored in mocks/testimonials.ts; proper names (boats, places) need no entry.
export default {
  reviews: {
    tourNames: {
      'Passeio de Lancha Privativa': "Passeio de Lancha Privativa",
    },
  },
};
